// 🟦3 料金区分。確定時スナップショット（row.feeCategory/feeAmount・website が申込確定時に保存）を優先。
// 未記録（admin 登録・旧データ）のみ website と同ルールで算出：幼少（兄弟割引なし）→ 兄弟（row.sibling）→ 一般。
// 判定区分の金額が未設定(null/"")なら一般。
export const resolveFee = (row, fees, youngIds) => {
  if (!row) return { category: "general", amount: 0 };
  if (row.feeCategory) {
    return { category: row.feeCategory, amount: Number(row.feeAmount) || 0 };
  }
  const isYoung = (row.classKeys || []).some((k) => youngIds.has(k));
  const [category, amount] = isYoung
    ? ["young", fees.feeYoung]
    : row.sibling
      ? ["sibling", fees.feeSibling]
      : ["general", fees.feeGeneral];
  if (amount == null || amount === "") {
    return { category: "general", amount: Number(fees.feeGeneral) || 0 };
  }
  return { category, amount: Number(amount) || 0 };
};
